import { EventHandler } from "verdi-web-client/HelperFunctions";

/**
 * How the app tells the marker layers that something they draw has changed.
 *
 * Legacy map entities mutate in place without changing identity, so this is the only signal React has.
 * Only necessary because the legacy layer is non-reactive. Can be removed once legacy is retired.
 */

/**
 * A device's model or focus state changed, so its marker may look different.
 *
 * Fired for focus changes too, with the same payload a model write sends — a listener here cannot tell
 * an edit from a selection. Anything that must subscribes to `model.onChange` directly.
 *
 * Does not batch, so a poll burst is one call per changed device: consumers coalesce on their own timer
 * via `utils/coalesce.ts`. `EventHandler`'s `buffer` argument looks like it would batch and does not.
 */
export const deviceMarkerUpdateEvent = new EventHandler({});
